import { useState, useEffect, useRef } from 'react'
import { replenishmentPlanActions } from '@/data/replenishmentPlan/slice/replenishmentPlan.slice.ts'
import { selectSearch } from '@/data/replenishmentPlan/slice/replenishmentPlan.selectors.ts'
import { useTranslation } from 'react-i18next'
import { useDebounce } from 'use-debounce'
import '@/core/api/graphql/enhancedGraphqlApi.ts'
import { useDispatch, useSelector } from 'react-redux'
import { SearchInput } from '@/ui/components/SearchInput'
import { useSearchProducts } from '@/data/replenishmentPlan/hooks/useSearchProducts.ts'

const PlanTableSearchHeader = () => {
  const dispatch = useDispatch()

  const search = useSelector(selectSearch)

  const { searchProducts } = useSearchProducts()

  const [value, setValue] = useState(search)
  const [debouncedValue] = useDebounce(value, 500)

  const requestIdRef = useRef(0)

  const onChange = (value: string) => {
    setValue(value)
  }

  useEffect(() => {
    const trimmedValue = debouncedValue.trim()

    if (!trimmedValue) {
      dispatch(replenishmentPlanActions.handleClearPlanSearch())
      return
    }

    const currentRequestId = ++requestIdRef.current

    const performSearch = async () => {
      await searchProducts(trimmedValue)

      if (requestIdRef.current === currentRequestId) {
        dispatch(replenishmentPlanActions.setSearch(trimmedValue))
      }
    }

    performSearch()
  }, [debouncedValue, searchProducts, dispatch])

  const { t } = useTranslation()

  return (
    <SearchInput
      value={value}
      placeholder={t('planTableSearchHeader.placeholder')}
      onChange={onChange}
    />
  )
}

export default PlanTableSearchHeader
